module.exports = __webpack_public_path__ + "img/eisLogo.a2d772e4.png";